/* eslint-disable react/jsx-props-no-spreading */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { useCallback, useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';

import { useGame } from '../../contexts/GameContext';
import { useDisplay } from '../../contexts/LiveDisplayContext';
import { useThemeClassName } from '../../contexts/ThemeContext';
import Step from '../steps/Step';
import ScreensLayout from './ScreensLayout';

import styles from '../../../styles/displays/screens.module.scss';

const propTypes = {
    vertical: PropTypes.bool.isRequired,
};

function ScreensDisplay({ vertical }) {
    const themeClassName = useThemeClassName(styles);
    const game = useGame();
    const display = useDisplay();

    const {
        id: displayId = null,
        fixedStep = null,
        pageSteps: steps = null,
        games = null,
        leaderboard = null,
    } = display || {};

    const { id: fixedStepId = null } = fixedStep || {};
    const { questions = [], step: stepId = null } = game || {};

    const step = (steps || []).find(({ id }) => id === (fixedStepId || stepId)) || null;

    const stepParts = stepId !== null ? stepId.split('-') : null;
    const questionId = stepParts !== null && stepParts.length > 1 ? stepParts[1] : null;
    const question = (questions || []).find((q) => q.id === questionId) || null;
    const { endAt = null } = question || {};

    // Swaps display if necessary
    const { displaySteps = null } = step || {};
    const displayStepId =
        displaySteps !== null && typeof displaySteps[displayId] !== 'undefined'
            ? displaySteps[displayId]
            : null;
    const finalStep =
        displayStepId !== null
            ? (steps || []).find(({ id }) => id === displayStepId) || step
            : step;
    const { component = null } = finalStep || {};

    const [questionEnded, setQuestionEnded] = useState(false);
    const onTimerEnd = useCallback(() => setQuestionEnded(true), [setQuestionEnded]);
    useEffect(() => setQuestionEnded(false), [questionId, endAt]);

    const defaultComponent = displayId === 'display2' ? 'start' : 'games';
    const finalComponent = component === null ? defaultComponent : component;

    // console.log('game', game);
    // console.log('pageStep', pageStep);
    // console.log('steps', stepId, steps, component);
    // console.log('yo', steps, step, displaySteps, displayId, displayStepId, finalStep, component);

    return (
        <div
            className={classNames([
                styles.container,
                themeClassName,
                {
                    [styles.vertical]: vertical,
                    [styles[component]]: component !== null,
                },
            ])}
        >
            <Helmet>
                <style type="text/css">
                    {`
                :root {
                    --display-layout: '${vertical ? 'vertical' : 'horizontal'}';
                {
                `}
                </style>
            </Helmet>
            <ScreensLayout step={finalStep} game={game} question={question} onTimerEnd={onTimerEnd}>
                <Step
                    className={styles.step}
                    component={finalComponent}
                    step={finalStep}
                    game={game}
                    games={games}
                    leaderboard={leaderboard}
                    question={question}
                    isEnded={questionEnded}
                    vertical={vertical}
                    isDisplay
                    isPreview
                    isLive
                    disabled
                />
            </ScreensLayout>
        </div>
    );
}

ScreensDisplay.propTypes = propTypes;

export default ScreensDisplay;
